import React from 'react';
import { enumValue } from '~/util';
import { Notes } from '../Notes';

interface RiskGapAuditNotesProps {
    entityId: number;
    gap: RiskGapType;
}
export function RiskGapAuditNotes({ entityId, gap }: RiskGapAuditNotesProps) {
    return (
        <Notes
            canAdd={false}
            entityId={entityId}
            gap={gap}
            includeActions
            noteEntity="risk_gap.id"
            noteType={enumValue(['note', 'type', 'Risk Gap Note']) as number}
        />
    );
}
